// extracted by mini-css-extract-plugin
export default {"cls1":"Unibrow-cls1___fe0113a6f2ff3acc458","cls2":"Unibrow-cls2___49dd96b4e6fb71c5341 Unibrow-cls1___fe0113a6f2ff3acc458"};